const timeZoneToCurrencySymbol = {
    "Asia/Dubai": "AED",
    "Asia/Kolkata": "₹",
    "Asia/Baghdad": "IQD"
};


export const getCurrencySymbolByTimeZone = (timeZone) => {
    const unescapedTimeZone = timeZone?.replace(/\\/g, ""); 
    return timeZoneToCurrencySymbol[unescapedTimeZone] || "₹";
};
